export default __webpack_public_path__ + "static/media/Tissue.c3592027.gif";